import React, { useState } from "react";
import InfoIcon from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";

const SafeDriversCalcInfo = () => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <IconButton onClick={() => setOpen(true)}>
                <InfoIcon />
            </IconButton>
            <Dialog
                open={open}
                disableEscapeKeyDown
                disableBackdropClick
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Cálculo do piloto mais seguro</DialogTitle>
                <DialogContent>
                    <div>
                        O piloto só entrara no cálculo de piloto mais seguro, se
                        completar pelo menos 80% do máximo de voltas dadas.
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setOpen(false);
                        }}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export { SafeDriversCalcInfo };
